<div class="pdf-page app-aul-013-24" id="california1324">
  <!-- <app-policy-header></app-policy-header> -->
  <br />
  <p class="font-large" style="text-align: center">
    <b>AMENDATORY ENDORSEMENT</b>
  </p>
  <p class="font-large" style="text-align: center"><b>CALIFORNIA CHANGES</b></p>
  <p class="font-large" style="text-align: center">
    <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY</b>
  </p>
  <p class="font-medium">
    <b
      >This endorsement comprising of policyholder notices, coverage changes and
      endorsements attaches to and forms part of the policy numbered
      {{ this.policyDetails?.policyNo }}
    </b>
  </p>
  <br />
  <br />
  <p class="font-medium" style="text-decoration: underline">
    <b><u>SURPLUS LINES DISCLOSURE NOTICE</u></b>
  </p>
  <ol class="font-medium">
    <li>
      THE INSURANCE POLICY THAT YOU [HAVE PURCHASED] [ARE APPLYING TO PURCHASE] IS BEING ISSUED BY AN INSURER THAT IS NOT LICENSED BY THE STATE OF
      CALIFORNIA. THESE COMPANIES ARE CALLED “NONADMITTED” OR “SURPLUS LINE” INSURERS.
    </li>
    <li>
      THE INSURER IS NOT SUBJECT TO THE FINANCIAL SOLVENCY REGULATION AND ENFORCEMENT THAT APPLY TO CALIFORNIA LICENSED INSURERS.
    </li>
    <li>
      THE INSURER DOES NOT PARTICIPATE IN ANY OF THE INSURANCE GUARANTEE FUNDS CREATED BY CALIFORNIA LAW. THEREFORE, THESE FUNDS WILL NOT PAY YOUR CLAIMS
      OR PROTECT YOUR ASSETS IF THE INSURER BECOMES INSOLVENT AND IS UNABLE TO
      MAKE PAYMENTS AS PROMISED.
    </li>
  </ol>
</div>

<div class="pdf-page app-aul-013-24">
  <ol type="1" start="4" class="font-medium">
    <li>
      <p>
        THE INSURER SHOULD BE LICENSED EITHER AS A FOREIGN INSURER IN ANOTHER
        STATE IN THE UNITED STATES OR AS A NON-UNITED STATES (ALIEN) INSURER.
        YOU SHOULD ASK QUESTIONS OF YOUR INSURANCE AGENT, BROKER, OR “SURPLUS
        LINE” BROKER OR CONTACT THE CALIFORNIA DEPARTMENT OF INSURANCE AT THE
        FOLLOWING
      </p>
      <p>
        TOLL-FREE TELEPHONE NUMBER 800-927-4357 OR INTERNET WEB SITE
        WWW.INSURANCE.CA.GOV. ASK WHETHER OR NOT THE INSURER IS LICENSED AS A
        FOREIGN OR NON-UNITED STATES (ALIEN) INSURER AND FOR ADDITIONAL
        INFORMATION ABOUT THE INSURER. YOU MAY ALSO CONTACT THE NAIC'S INTERNET
        WEB SITE AT
        <a>WWW.NAIC.ORG</a>
      </p>
    </li>
    <li>
      FOREIGN INSURERS SHOULD BE LICENSED BY A STATE IN THE UNITED STATES AND
      YOU MAY CONTACT THAT STATE'S DEPARTMENT OF INSURANCE TO OBTAIN MORE
      INFORMATION ABOUT THAT INSURER.
    </li>
    <li>
      FOR NON-UNITED STATES (ALIEN) INSURERS, THE INSURER SHOULD BE LICENSED BY
      A COUNTRY OUTSIDE OF THE UNITED STATES AND SHOULD BE ON THE NAIC'S
      INTERNATIONAL INSURERS DEPARTMENT (IID) LISTING OF APPROVED NONADMITTED
      NON-UNITED STATES INSURERS. ASK YOUR AGENT, BROKER, OR “SURPLUS LINE”
      BROKER TO OBTAIN MORE INFORMATION ABOUT THAT INSURER.
    </li>
  </ol>
</div>
<div class="pdf-page app-aul-013-24">
  <ol type="b" start="7" class="font-medium">
    <li>
      CALIFORNIA MAINTAINS A LIST OF APPROVED SURPLUS LINE INSURERS. ASK YOUR
      AGENT OR BROKER IF THE INSURER IS ON THAT LIST, OR VIEW THAT LIST AT THE
      INTERNET WEB SITE OF THE CALIFORNIA DEPARTMENT OF INSURANCE:
      <a>WWW.INSURANCE.CA.GOV</a>
    </li>
    <li>
      IF YOU, AS THE APPLICANT, REQUIRED THAT THE INSURANCE POLICY YOU HAVE
      PURCHASED BE BOUND IMMEDIATELY, EITHER BECAUSE EXISTING COVERAGE WAS GOING
      TO LAPSE WITHIN TWO BUSINESS DAYS OR BECAUSE YOU WERE REQUIRED TO HAVE
      COVERAGE WITHIN TWO BUSINESS DAYS, AND YOU DID NOT RECEIVE THIS DISCLOSURE
      FORM AND A REQUEST FOR YOUR SIGNATURE UNTIL AFTER COVERAGE BECAME
      EFFECTIVE, YOU HAVE THE RIGHT TO CANCEL THIS POLICY WITHIN FIVE DAYS OF
      RECEIVING THIS DISCLOSURE. IF YOU CANCEL COVERAGE, THE PREMIUM WILL BE
      PRORATED AND ANY BROKER'S FEE CHARGED FOR THIS INSURANCE WILL BE RETURNED
      TO YOU.
    </li>
  </ol>
  <div>
    <div>
      <p class="font-medium">
        <b
          ><span style="text-decoration: underline"
            >SERVICE OF SUIT CLAUSE</span
          ></b
        >
      </p>
    </div>
    <div>
      <p class="font-medium">
        <u>FORTEGRA SPECIALTY INSURANCE COMPANY</u>
      </p>
    </div>
    <div>
      <p class="font-medium">(NAIC# 16823)</p>
      <br />
      <p class="font-medium">
        It is agreed that in the event of the failure of the Company to pay any
        amount claimed to be due hereunder, the Company, at the request of the
        Named Insured, will submit to the jurisdiction of a court of competent
        jurisdiction within the United States and will comply with all
        requirements necessary to give such court jurisdiction and all matters
        arising hereunder shall be determined in accordance with the law and
        practice of such court. Nothing in this clause constitutes or should be
        understood to constitute a waiver of the Company’s rights to commence an
        action in any court of competent jurisdiction in the United States, to
        remove an action to a United States District Court, or to seek a
        transfer of a case to another court as permitted by the laws of the
        United States or of any state in the United States.
      </p>
      <br />
      <p class="font-medium">SERVICE OF SUIT - CALIFORNIA</p>
      <br />
      <p class="font-medium">
        It is further agreed that service of process in such suit may be made
        upon:
      </p>
      <br />
      <p class="font-medium">
        <b>Corporate Creations Network Inc. [C2250455] </b>
      </p>
      <p class="font-medium">
        <b>7801 Folsom Boulevard, #202</b>
      </p>
      <p class="font-medium">
        <b>Sacramento, CA 95826</b>
      </p>
      <p class="font-medium">
        <b>Sacramento County</b>
      </p>
      <p class="font-medium">
        <b>Phone: (561) 694-8107</b>
      </p>
      <br />
      <p class="font-medium">
        and that in any suit instituted against the Company upon this policy,
        the Company will abide by the final decision of such court or of any
        appellate court in the event of an appeal. Further, pursuant to any
        statute of any state, territory or district of the United States which
        makes provision therefor, the Company hereby designates the
        Superintendent, Commissioner, or Director of Insurance or other official
        specified for that purpose in the statute, or his/her successor or
        successors in office, as its true and lawful attorney upon whom may be
        served any lawful process in any action, suit or proceeding instituted
        by or on behalf of the Named Insured or any beneficiary hereunder
        arising out of this policy, and hereby designates the above-named as to
        whom the said officer is authorized to mail such process or a true copy
        thereof. Pursuant to Section 1772, et seq., of the California Insurance
        Code, a surplus line insurer may be sued upon any cause of action
        arising in this state under any surplus line insurance contract made by
        it, or any evidence of insurance issued or delivered by the surplus line
        broker, pursuant to the procedures set forth in Sections 1610 to 1620,
        inclusive
      </p>
    </div>
    <p class="font-medium">FSIC SOS CA (01 25)</p>
  </div>
</div>
